import { NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StorageService } from '../../../services/storage.service';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-nav-bar',
  imports: [NgFor, RouterLink],
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.css'
})
export class NavBarComponent implements OnInit {
  get selectedCategory(): string {
    return this.storage.getSelectedCategory() || 'all';
  }
  @Input() categories: Array<any> = [];
  mFilteredCategories: Array<any> = [];
  moreCategories: Array<any> = [];
  @Output() sendSelectedCategory: EventEmitter<{ category: string; option: string }> = new EventEmitter()
  // defaultCategory: Array<any> = [
  //   { name: "Trending", id: "trending" },
  //   { name: "Breaking", id: "breaking" },
  //   { name: "New", id: "new" }
  // ];

  constructor(private storage: StorageService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // listening category api updates from storage service.
    this.categories = this.storage.getCategoryData();
    this.storage
      .categoryUpdate$
      .subscribe((result: boolean) => {
        if (result === true) {
          this.categories = this.storage.getCategoryData();
          if (this.categories.length > 13) {
            this.mFilteredCategories = this.categories.slice(0, 13);
            this.moreCategories = this.categories.slice(13, this.categories.length);
          } else {
            this.mFilteredCategories = this.categories;
          }
          
          if (this.storage.getSelectedCategory()) {
            this.selectCategory(this.storage.getSelectedCategory(), 'dynamic', false);
          } else {
            this.selectCategory('all', 'default', false);
          }
        }
      });
  }

  /**
   * Selects a category to display in the main component.
   * @param {string} category - The category to select.
   * @param {string} [option='default'] - The option to select.
   * @param {boolean} [redirect=true] - Whether to redirect to the homepage after selecting the category.
   * @returns {void}
   */
  selectCategory(category: string, option: string = 'default', redirect: boolean = true): void {
    this.storage.setSelectedCategory(category);

    if (redirect) {
      this.router.navigate(['/']);
    }
    this.sendSelectedCategory.next({ category, option });
  }
}
